var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6783 0.991702L22.327 8.01716C22.5997 8.54237 23.1269 8.90605 23.7365 8.9901L31.8951 10.1168C33.4306 10.3288 34.0437 12.1217 32.9327 13.1513L27.0293 18.6199C26.5879 19.0287 26.3869 19.6175 26.4908 20.1943L27.8844 27.9164C28.1467 29.3695 26.5418 30.4777 25.1685 29.7918L17.8711 26.146C17.3257 25.8733 16.6743 25.8733 16.1289 26.146L8.83152 29.7918C7.45824 30.4777 5.85328 29.3699 6.11559 27.9164L7.50915 20.1943C7.61313 19.6175 7.41208 19.0283 6.97071 18.6199L1.0673 13.1513C-0.0436645 12.1221 0.569414 10.3292 2.10491 10.1168L10.2635 8.9901C10.8731 8.90605 11.4003 8.54196 11.673 8.01716L15.3217 0.991702C16.0081 -0.330567 17.9923 -0.330567 18.6787 0.991702H18.6783Z",
    fill: "#FFD400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.08d3a901.svg";
export { ForwardRef as ReactComponent };